// extracted by mini-css-extract-plugin
export default {"container":"footer_container__EQADA","content":"footer_content__efFzO","link":"footer_link__b57wm","item":"footer_item__lchGE","footer":"footer_footer__uibyJ"};